import {request} from "@/utils/Request";
import  type {UserResponse} from "./Types";

export const getUserInfo = () => {
  return request.get<UserResponse>("/api/user/nowusr", {});
};
